import {
  LEGEND_OPEN,
  LEGEND_CLOSE,
  TOGGLE_LEGEND,
} from '../common/actionTypes';

export default (state = true, action) => {
  switch(action.type) {
    case LEGEND_OPEN:
      return true;
    case LEGEND_CLOSE:
      return false;
    case TOGGLE_LEGEND:
      return !state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./map/reducers/legendReducer.js